import type { ReactNode } from 'react'
import { Modal } from './Modal'

export interface EntityFormModalProps {
  open: boolean
  /** e.g. "Firm", "Document Type" - becomes "New <entityLabel>" /
   * "Duplicate <entityLabel>" in the title, with "Create"/"Duplicate" on
   * the confirm button. */
  entityLabel: string
  isDuplicate: boolean
  isValid: boolean
  /** Used by Cancel and the title-bar close - pass the modal's own close
   * handler, so it can reset its seeded fields (useSeededModalField). */
  onClose: () => void
  onConfirm: () => void
  children: ReactNode
}

// The title and Cancel/Create-or-Duplicate footer every "New or Duplicate
// <entity>" modal shares; the body (which fields, which validation
// messages) stays in each modal. PRD 14.
export function EntityFormModal({
  open,
  entityLabel,
  isDuplicate,
  isValid,
  onClose,
  onConfirm,
  children,
}: EntityFormModalProps) {
  return (
    <Modal
      open={open}
      title={isDuplicate ? `Duplicate ${entityLabel}` : `New ${entityLabel}`}
      onClose={onClose}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            className="rounded-control border border-border px-4 py-2 text-body font-medium text-text-primary"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={!isValid}
            onClick={onConfirm}
            className="rounded-control bg-accent px-4 py-2 text-body font-medium text-white disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isDuplicate ? 'Duplicate' : 'Create'}
          </button>
        </>
      }
    >
      {children}
    </Modal>
  )
}
